// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__2mL7b","logo":"Loader_logo__fRZFH"};